// extracted by mini-css-extract-plugin
module.exports = {"link":"_93444fe79c--link--3fW1W","title":"_93444fe79c--title--2D6Qs","image":"_93444fe79c--image--3VGTm"};